import { render, staticRenderFns } from "./Align.vue?vue&type=template&id=68aca204"
import script from "./Align.vue?vue&type=script&lang=js"
export * from "./Align.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports